import React from 'react';
import {colorBackground} from "./items/mapdata";
import {t} from "i18next";

const FooterTableTimekeeping = (props) => {
    // return (
    //     <div className={" flex items-center footer-table bottom-4 absolute pl-6 pt-2 "}>
    //
    //         <div className={"w-[30px] h-[30px] block-note-timekeeping"}
    //              style={{background: colorBackground.workday, marginRight: 8}}/>
    //         {t("tnp.components.timesheetViewport.text7")}
    //         <div className={"w-[30px] h-[30px] block-note-timekeeping"}
    //              style={{
    //                  background: colorBackground.leaveNoReason,
    //                  marginRight: 8,
    //                  marginLeft: 8
    //              }}/>  {t("tnp.components.timesheetViewport.text8")}
    //         <div className={"w-[30px] h-[30px] block-note-timekeeping"}
    //              style={{background: colorBackground.casual, marginRight: 8, marginLeft: 8}}/>  {t("tnp.components.timesheetViewport.text4")}
    //         <div className={"w-[30px] h-[30px] block-note-timekeeping"}
    //              style={{background: colorBackground.manual, marginRight: 8, marginLeft: 8}}/>  {t("tnp.components.timesheetViewport.text9")}
    //         <div className={"w-[30px] h-[30px] block-note-timekeeping"}
    //              style={{
    //                  background: colorBackground.holiday,
    //                  marginRight: 8,
    //                  marginLeft: 8
    //              }}/>  {t("tnp.components.timesheetViewport.text3")}
    //         <div className={"w-[30px] h-[30px] block-note-timekeeping"}
    //              style={{
    //                  background: colorBackground.editManual,
    //                  marginRight: 8,
    //                  marginLeft: 8
    //              }}/>
    //         {t("tnp.components.timesheetViewport.text1")}
    //     </div>);

    return (
        <div className="flex items-center footer-table bottom-4 absolute pl-6 pt-2 space-x-2">
            <div className="w-[30px] h-[30px] block-note-timekeeping" style={{ background: colorBackground.workday }} />
            <span>{t("tnp.components.timesheetViewport.text7")}</span>

            <div className="w-[30px] h-[30px] block-note-timekeeping" style={{ background: colorBackground.leaveNoReason }} />
            <span>{t("tnp.components.timesheetViewport.text8")}</span>

            <div className="w-[30px] h-[30px] block-note-timekeeping" style={{ background: colorBackground.casual }} />
            <span>{t("tnp.components.timesheetViewport.text4")}</span>

            <div className="w-[30px] h-[30px] block-note-timekeeping" style={{ background: colorBackground.manual }} />
            <span>{t("tnp.components.timesheetViewport.text9")}</span>

            <div className="w-[30px] h-[30px] block-note-timekeeping" style={{ background: colorBackground.holiday }} />
            <span>{t("tnp.components.timesheetViewport.text3")}</span>

            <div className="w-[30px] h-[30px] block-note-timekeeping" style={{ background: colorBackground.editManual }} />
            <span>{t("tnp.components.timesheetViewport.text1")}</span>
        </div>
    );

};

FooterTableTimekeeping.propTypes = {};

export default FooterTableTimekeeping;
